import React from "react";
import ScrollFloat from './ScrollFloat';

function FeaturesDetail() {
  return (
    <>
      <div className="bg-slate-100">
        <div className="container mx-auto space-y-10">
          <div className="flex flex-col justify-center items-center mb-8">
            <h2 className="text-center text-base/7 uppercase text-slate-400">Features</h2>
            
          <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">  
                <ScrollFloat
                animationDuration={1}
                ease='back.inOut(2)'
                scrollStart='center bottom+=50%'
                scrollEnd='bottom bottom-=40%'
                stagger={0.03}
              >Everything you need to rank your startup
              </ScrollFloat>
              </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Website Audits */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 tracking-tight text-balance px-14 pt-14">Website Audits</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Audit tool offers an in-depth look into your site’s SEO health, page quality, and performance. Designed for quick, actionable insights.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">SEO Audit</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Improve keywords, meta tags, and technical SEO for better visibility.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Page Quality Check</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Ensure smooth navigation, mobile-friendliness, and clear content on every page.</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Quick Improvements</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Get prioritized recommendations to boost SEO, content, and speed.</p>
                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Core Web Vitals</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Check speed, accessibility, and user experience based on Google’s standards.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tasks Manager */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 tracking-tight text-balance px-14 pt-14">Tasks Manager</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Organize your workflow, manage your to-do lists, and keep projects moving forward with ease.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Simple Organization</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Create, edit and categorize tasks to stay focused and in control of your daily work.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Task Tracking</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Assign tasks, set deadlines and track progress great for individuals or teams.</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                       <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Progress Overview</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Quickly view your task status and overall project momentum at a glance.</p>

                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                                         </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Backlinks Analysis */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 px-14 pt-14">Backlinks Analysis</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Our Backlinks feature provides essential insights to help you manage and strengthen your backlink strategy.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">By Month</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Monitor backlink growth month-by-month to understand trends and impact.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Top Referring Domains</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">See which domains drive the most value and authority to your site.</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Detail List</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Access a full list of backlinks with domain details, URLs, and DA.</p>
                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Broken Backlinks</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Easily identify and repair broken backlinks to retain link value.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Keyword Research */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 px-14 pt-14">Keywords Research</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Our Keyword Research tool provides the insights you need to target the right keywords and drive more traffic.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Keyword Suggestions</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Get a list of keyword ideas tailored to your niche and audience.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Monthly Volume</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">See the monthly search volume to prioritize high-interest keywords.</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Competitions</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Understand how competitive each keyword is to improve targeting.</p>
                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Trend Rate</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Monitor changes in search popularity to stay ahead of market shifts.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Competitor Analysis */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 px-14 pt-14">Competitor Analysis</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Our Competitor Analysis tool helps you understand and outpace your competition.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Common Keywords</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Discover the keywords you and your competitors both target.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Gap Keywords</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Find keywords your competitors rank for that you’re missing.</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Estimate Traffic</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">View estimated traffic to understand your competitors' online visibility.</p>
                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Ranked List</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Get a ranked list of competitors based on traffic and keyword performance.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rank Monitor */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 px-14 pt-14">Rank Monitor</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Our Rank Monitor tool helps you stay updated on keyword rankings and make data-driven improvements.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Rank History</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">View historical ranking data to measure growth and performance trends.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">SERP by Keyword</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Check where your keywords stand in search engine results pages (SERPs).</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Ranked URL</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Discover which URLs are ranking for each keyword to optimize and refine content.</p>
                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950 flex items-center">
                        Compare Structure
                        <span className="text-xs bg-green-500 text-white rounded px-3 py-1 ml-2">new</span>
                      </h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Compare top-ranked pages with your page structure to understand why Google prefers them.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* AI Tools */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 px-14 pt-14">AI Tools</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Our AI tools can help you improve rankings, optimize on-page content, and create SEO-ready blog posts with ease.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Ask SeoChan</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Receive actionable improvement suggestions and next-step guidance based on your website data.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">AI Blog Writer</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Effortlessly create engaging, SEO-friendly blog content tailored to your audience.</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">AI Visibility Check</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Evaluate how well your content is performing across search visibility metrics.</p>
                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">AI Code Suggestion</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Get smarter, faster coding with AI-powered suggestions for technical optimization.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Cookieless Analytics */}
            <div className="bg-white rounded-lg border border-slate-200 text-left">
              <div className="text-left flex items-center">
                <div>
                  <h3 className="mb-5 text-3xl font-medium tracking-tight text-gray-950 px-14 pt-14">Cookieless Analytics</h3>
                  <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-14">
                    Gain deep insights into user behavior without relying on cookies, fully privacy-compliant and future-proof.
                  </p>
                  <div className="grid md:grid-cols-2 mt-10 bg-slate-50 m-8">
                    <div className="border-t border-l p-5 rounded-tl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Privacy First Tracking</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Understand your audience while respecting privacy and compliance standards.</p>
                    </div>
                    <div className="border-t border-x p-5 rounded-tr-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Accurate Data Insights</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Get reliable engagement and conversion data without third party cookies.</p>
                    </div>
                    <div className="border-b border-l border-t p-5 rounded-bl-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">Future Ready Analytics</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Stay ahead with analytics built for a privacy first future.</p>
                    </div>
                    <div className="border-b border-x border-t p-5 rounded-br-lg hover:bg-white">
                      <h2 className="mb-2 text-xl font-medium tracking-tight text-gray-950">No Cookie Consent Needed</h2>
                      <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]">Run lightweight analytics without interrupting the user experience with banners.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div> {/* end grid */}
        </div> {/* end container */}
      </div> {/* end bg */}
    </>
  );
}

export default FeaturesDetail;
